module.exports = __webpack_public_path__ + "static-v-shop/1786461253957/img/cristal-ojo-derecho.97db1314.png";